import React from "react";
import Layout from "../common/components/Layout";
// import {ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";

const StatCard = ({ title, count, link, icon, color }) => (
  <div className="col-md-4">
    <Link to={link} className="text-decoration-none">
      <div 
        className="p-4 h-100 transition-up"
        style={{
          backgroundColor: "rgba(255, 255, 255, 0.7)", 
          backdropFilter: "blur(12px)",
          borderRadius: "16px",
          border: "1px solid rgba(255, 255, 255, 0.3)", 
          transition: "transform 0.2s ease, box-shadow 0.2s ease",
          boxShadow: "0 4px 15px rgba(0,0,0,0.05)"
        }}
      >
        <div className="d-flex justify-content-between align-items-start mb-3">
          <div 
            className="rounded-circle d-flex align-items-center justify-content-center"
            style={{ width: "45px", height: "45px", backgroundColor: `${color}15`, color: color }}
          >
            <i className={`bi ${icon} fs-5`}></i>
          </div>
          <i className="bi bi-arrow-up-right text-muted small"></i>
        </div>
        <h6 className="text-muted fw-bold small text-uppercase mb-1" style={{ fontSize: '0.65rem', letterSpacing: '1px' }}>{title}</h6>
        <h2 className="fw-bold m-0 text-dark" style={{ letterSpacing: "-1px" }}>{count}</h2>
      </div>
    </Link>
  </div>
);

const MasterData = () => {


  return (
    <Layout>
      <style>{`
        .transition-up:hover { 
          transform: translateY(-5px); 
          box-shadow: 0 10px 25px rgba(0,0,0,0.1) !important;
          background-color: rgba(255, 255, 255, 0.9) !important;
        }
      `}</style>

      <div className="container-fluid py-2">
        <div className="mb-4 pt-2">
          <h1 className="fw-bold text-dark mb-1" style={{ letterSpacing: "-1.5px" }}>Master Data</h1>
          <p className="text-muted small">Data Maintenance</p>
        </div>

        {/* Top Metrics */}
        <div className="row g-4 mb-4">
          <StatCard 
            title="Leaves"
            icon="bi-calendar-event" 
            
            color="#6366f1" 
          />
          <StatCard title="Assets"  icon="bi bi-suitcase-lg"  color="#f59e0b" />
          <StatCard title="Traning" icon="bi-person-plus" color="#10b981" />
        </div>

      </div>
    </Layout>
  );
};

export default MasterData;